module.exports = __webpack_public_path__ + "img/Key_Considerations_for_Success_Cloud_Adoption_in_Financial_Services.7a4dae24.jpg";